import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import UserModel from "../../models/user";

export default class UserRepository extends BaseRepository {
  static modelClass = UserModel;
  modelName = "user";
}
